/* ============
 * Getters for the account module
 * ============
 *
 * The getters that are available on the
 * account module.
 */

export default {
  sections: state => { return state.sections },
  section: state => { return _.groupBy(state.section, 'zone'); },
  blocks: state => { return state.section.blocks },
  block: state => { return state.section.blocks },
  findSectionById: state => id => {
    //Before filtering by ID flatten section to remove gropping by zone
    return _.filter(_.flatMap(state.section), function(o) {
      return o.id == id;
    })[0];
  },
  findBlockById: state => (id, blockId) => {
    let sectionSelected = _.filter(state.section, function(o) { return o.id == id; });
    if (sectionSelected.length > 0) {
      return _.filter(sectionSelected[0].blocks, function(o) { return o.id == blockId; })[0];
    }
  }
};
